import { DOCUMENT } from '@angular/common';
import { EventEmitter, Inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { StorageService } from '../../../../core/services/storage.service';

declare let grecaptcha: any;
@Injectable({ providedIn: 'root' })
export class RecaptchaService {
  googleSDKInitializationed = false;
  private googleApisJs = '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private storageService: StorageService,
  ) {
    this.googleApisJs = `https://www.google.com/recaptcha/enterprise.js?onload=initRecaptcha&hl=${this.storageService.i18n.value}`;
  }

  initGoogleSDK(elmId: string) {
    const onResponse = new EventEmitter<string | null>();

    return new Promise<typeof onResponse>((resolver, reject) => {
      if (this.googleSDKInitializationed) {
        resolver(onResponse);
        this.watchChanges(elmId, onResponse);
        return;
      }

      const googleSDKScriptId = 'recaptchaGoogleSDK';
      let script = this.document.getElementById(
        googleSDKScriptId,
      ) as HTMLScriptElement;
      if (script && (this.document.defaultView as any)['grecaptcha']) {
        this.googleSDKInitializationed = true;
        this.watchChanges(elmId, onResponse);
        resolver(onResponse);

        return;
      }

      (this.document.defaultView as any)['initRecaptcha'] = () => {
        this.googleSDKInitializationed = true;
        this.watchChanges(elmId, onResponse);
        resolver(onResponse);
      };

      script = this.document.createElement('script');
      script.id = googleSDKScriptId;
      script.src = this.googleApisJs;
      script.async = true;
      script.defer = true;
      this.document.body.insertAdjacentElement('beforeend', script);
    });
  }

  private watchChanges(elmId: string, onResponse: EventEmitter<string | null>) {
    // console.log('elmId', elmId);

    grecaptcha.enterprise.render(elmId, {
      sitekey: environment.google.recaptchaKey,
      theme: 'light',
      callback: (response: any) => {
        onResponse.emit(response);
      },
    });
    this.expiredCallback(onResponse);
  }

  expiredCallback(onResponse: EventEmitter<string | null>) {
    (this.document.defaultView as any)['expiredCallback'] = () => {
      onResponse.emit(null);
    };
  }
}
